"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./ProfileIcon.css");
var Icon_1 = require("../Icon");
exports.ProfileIconComp = function (_a) {
    var title = _a.title, imageSrc = _a.imageSrc, checked = _a.checked, props = __rest(_a, ["title", "imageSrc", "checked"]);
    return (React.createElement("div", __assign({}, props, { className: classnames_1.default('ProfileIcon', props.className) }),
        React.createElement("div", { className: "ProfileIcon_bg" }, imageSrc ? (React.createElement("img", { className: 'ProfileIcon_image', src: imageSrc, alt: ' ' })) : (React.createElement("span", { "aria-hidden": true }, title))),
        checked && (React.createElement("span", { className: 'ProfileIcon_check' },
            React.createElement(Icon_1.Icon, { type: Icon_1.IconType.check })))));
};
exports.ProfileIcon = React.memo(exports.ProfileIconComp);
